import { rgba } from 'polished';
import { noop } from 'lodash/noop';
import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';
import { DEPRECATED, slate40 } from '@zocdoc-mezzanine/foundations-colors';
import { FontFamily } from '@zocdoc-frontend-common/styles-typography';

const Notice = ({
    className,
    children,
    showNotice,
    isError,
    onClick = noop,
}) => {
    if (!showNotice) return null;

    return (
        <Text
            className={className}
            clickable={onClick !== noop}
            data-test="notice"
            hasError={isError}
            onClick={onClick}
        >
            {children}
        </Text>
    );
};

Notice.propTypes = {
    showNotice: PropTypes.bool,
};

const Text = styled.div`
    background-color: ${p => (p.hasError ? '#FFECF1' : 'transparent')};
    border: solid 1px
        ${p => (p.hasError ? DEPRECATED.tertiaryCoral : rgba(slate40, 0.5))};
    font: 15px/24px ${FontFamily.SharpSansMedium};
    padding: 8px 16px;
    margin-top: 8px;
    ${p =>
        p.clickable &&
        css`
            cursor: pointer;
        `}
`;

export default Notice;
